export default __webpack_public_path__ + "static/media/gameoverSound.d0697607.mp3";